import React from "react";

import Camicia from "./camicia";

const Viste = (props) => {
  const { tessuto } = props;

  return <Camicia tessuto={tessuto} />;
};

export default Viste;
